// extracted by mini-css-extract-plugin
export var standaloneTable = "_e2-0";
export var standaloneTableWithBodyFill = "_e2-1";
export var withExtraHeader = "_e2-2";